/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "subject2";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface SubjectDetectionMode {
}

export enum SubjectDetectionMode_Enum {
  INVALID = 0,
  DEFAULT = 4,
  SITE_SCAN = 3,
  UNRECOGNIZED = -1,
}

export function subjectDetectionMode_EnumFromJSON(object: any): SubjectDetectionMode_Enum {
  switch (object) {
    case 0:
    case "INVALID":
      return SubjectDetectionMode_Enum.INVALID;
    case 4:
    case "DEFAULT":
      return SubjectDetectionMode_Enum.DEFAULT;
    case 3:
    case "SITE_SCAN":
      return SubjectDetectionMode_Enum.SITE_SCAN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SubjectDetectionMode_Enum.UNRECOGNIZED;
  }
}

export function subjectDetectionMode_EnumToJSON(object: SubjectDetectionMode_Enum): string {
  switch (object) {
    case SubjectDetectionMode_Enum.INVALID:
      return "INVALID";
    case SubjectDetectionMode_Enum.DEFAULT:
      return "DEFAULT";
    case SubjectDetectionMode_Enum.SITE_SCAN:
      return "SITE_SCAN";
    case SubjectDetectionMode_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseSubjectDetectionMode(): SubjectDetectionMode {
  return {};
}

export const SubjectDetectionMode = {
  encode(_: SubjectDetectionMode, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SubjectDetectionMode {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubjectDetectionMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SubjectDetectionMode {
    return {};
  },

  toJSON(_: SubjectDetectionMode): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SubjectDetectionMode>, I>>(base?: I): SubjectDetectionMode {
    return SubjectDetectionMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubjectDetectionMode>, I>>(_: I): SubjectDetectionMode {
    const message = createBaseSubjectDetectionMode();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
